module.exports = __webpack_public_path__ + "img/16.73b595a2.png";